import styled from "styled-components";

export const quillStylesheet = `
  .quill-html p {
    font-size: 15px;
    line-height: 1.45;
  }

  .quill-html .ql-size-large {
    font-size: 20px;
    font-weight: 500;
  }

  .quill-html em {
    font-style: italic;
  }

  .quill-html strong {
    font-weight: bold;
  }

  .quill-html a {
    color: var(--color, --main-color) !important;
    font-weight: 500;
  }
`;

export const QuillHtml = styled.div`
  ${quillStylesheet}
`;
